/**
 * this is added for https://wandb.atlassian.net/browse/WB-16553
 * number chosen is non-scientific, so may be able to be adjusted
 */
export const MAX_VISIBLE_LINE_LENGTH = 5000;
export const DEFAULT_LINE_HEIGHT = 22;
export const COMPACT_LINE_HEIGHT = 16; // applied if there are no timestamps or labels displayed
export const TRUNCATED_LABEL_MAX_CHARS = 16;
export const REGEX_RUN_ID =
  /WANDB_PROJECT='(.*)'.*WANDB_ENTITY=([a-z0-9\-_]*).*WANDB_RUN_ID=([a-z0-9]+)/;
export const UNLABELED = 'Unlabeled';
export const OUTER_PADDING = 16;
